import { InjectionToken } from '@angular/core';
import { BaseConfigService } from '../services/base-config.service';

export const APPLICATION_CONFIGURATION_SERVICE = new InjectionToken<BaseConfigService>('APPLICATION_CONFIGURATION_SERVICE');
